<div class="viewer-container">
    <div
        class="spinner-container h-100"
        [style.display]="isLoading() ? 'flex' : 'none'">
        <kno2-loading-spinner></kno2-loading-spinner>
    </div>
    <div id="doc-viewer-container">
        <pdf-viewer
            class="doc-viewer"
            [src]="pdfSrc()"
            [cache]="true"
            [zoom]="effectiveOptions().zoom || 'auto'"
            [print]="effectiveOptions().print || 'enabled'"
            [download]="effectiveOptions().download || 'enabled'"
            [rotate]="effectiveOptions().rotate || 'enabled'"
            [remove]="effectiveOptions().remove || 'enabled'"
            [paging]="effectiveOptions().paging || 'enabled'"
            [thumbnails]="effectiveOptions().thumbnails || 'enabled'"
            (load)="onLoad()"
            (pagesInit)="onPagesInit()"
            (pageRotate)="onPageRotate($event)"
            (pageRemove)="onPageRemove($event)"
            (documentReload)="onDocumentReload()"
            (pagesLoaded)="onPagesLoaded()"></pdf-viewer>
    </div>
</div>
